// ── Launch Directories Data ─────────────────────────────────────

export interface DirectoryEntry {
  name: string;
  url?: string;
  category: "ai" | "startup" | "saas" | "general" | "community" | "deals";
  priority: "high" | "medium" | "low";
}

export const LAUNCH_DIRECTORIES: DirectoryEntry[] = [
  { name: "ProductHunt", category: "startup", priority: "high" },
  { name: "Hacker News", category: "community", priority: "high" },
  { name: "Indie Hackers", category: "community", priority: "high" },
  { name: "BetaList", category: "startup", priority: "high" },
  { name: "AlternativeTo", category: "general", priority: "high" },
  { name: "Y Combinator", category: "startup", priority: "high" },
  { name: "AppSumo", category: "deals", priority: "high" },
  { name: "Crunchbase", category: "startup", priority: "high" },
  { name: "There's An AI For That", category: "ai", priority: "high" },
  { name: "GrowthHackers", category: "community", priority: "high" },
  { name: "SaaSHub", category: "saas", priority: "high" },
  { name: "Ben's Bites", category: "ai", priority: "high" },
  { name: "Reddit", category: "community", priority: "high" },
  { name: "Futurepedia", category: "ai", priority: "high" },
  { name: "10Words", category: "startup", priority: "medium" },
  { name: "300 AI Directories", category: "ai", priority: "medium" },
  { name: "About.me", category: "general", priority: "low" },
  { name: "AI Directories", category: "ai", priority: "medium" },
  { name: "AI Launch", category: "ai", priority: "medium" },
  { name: "AI Scout", category: "ai", priority: "medium" },
  { name: "AIToolFame", category: "ai", priority: "low" },
  { name: "AItoolonline", category: "ai", priority: "low" },
  { name: "Aixploria", category: "ai", priority: "low" },
  { name: "Alternative.me", category: "general", priority: "medium" },
  { name: "Awesome Directories", category: "general", priority: "low" },
  { name: "BacklinkGPT", category: "ai", priority: "low" },
  { name: "BestOfWebsite", category: "general", priority: "low" },
  { name: "BetaPage", category: "startup", priority: "medium" },
  { name: "Buildspace Demo Day", category: "startup", priority: "medium" },
  { name: "ConfettiSaaS", category: "saas", priority: "low" },
  { name: "Crozdesk", category: "saas", priority: "medium" },
  { name: "CutAndShip", category: "startup", priority: "low" },
  { name: "DailyPings", category: "startup", priority: "low" },
  { name: "Dang", category: "startup", priority: "medium" },
  { name: "DesiFounder", category: "startup", priority: "low" },
  { name: "DevHunt", category: "community", priority: "medium" },
  { name: "Devpost", category: "community", priority: "medium" },
  { name: "DirectoryHunt", category: "general", priority: "low" },
  { name: "EverythingAITool", category: "ai", priority: "low" },
  { name: "F6S", category: "startup", priority: "medium" },
  { name: "Fazier", category: "startup", priority: "low" },
  { name: "FindlyTools", category: "ai", priority: "low" },
  { name: "First", category: "startup", priority: "low" },
  { name: "FiveTaco", category: "startup", priority: "low" },
  { name: "Foundrlist", category: "startup", priority: "low" },
  { name: "FutureTools", category: "ai", priority: "medium" },
  { name: "Hunt0", category: "startup", priority: "low" },
  { name: "Indie Deals", category: "deals", priority: "medium" },
  { name: "IndieHackerStacks", category: "community", priority: "low" },
  { name: "IndieTools", category: "community", priority: "low" },
  { name: "Insidr AI", category: "ai", priority: "medium" },
  { name: "KatseAI", category: "ai", priority: "low" },
  { name: "Lab Startups", category: "startup", priority: "low" },
  { name: "LaunchBoard", category: "startup", priority: "low" },
  { name: "LaunchDirectories", category: "general", priority: "low" },
  { name: "LaunchDubai", category: "startup", priority: "low" },
  { name: "LaunchIgniter", category: "startup", priority: "low" },
  { name: "LaunchingNext", category: "startup", priority: "medium" },
  { name: "LaunchTank", category: "startup", priority: "low" },
  { name: "LaunchUrApp", category: "startup", priority: "low" },
  { name: "LaunchVibe", category: "startup", priority: "low" },
  { name: "MadeLaunch", category: "startup", priority: "medium" },
  { name: "Makerlog", category: "community", priority: "medium" },
  { name: "Mars AI Directory", category: "ai", priority: "low" },
  { name: "MicroLaunch", category: "startup", priority: "medium" },
  { name: "Need Directory", category: "general", priority: "low" },
  { name: "NextBigProduct", category: "startup", priority: "low" },
  { name: "NoCodeList", category: "startup", priority: "low" },
  { name: "OpenAlternative", category: "general", priority: "medium" },
  { name: "PeerList", category: "community", priority: "medium" },
  { name: "Peerpush", category: "community", priority: "low" },
  { name: "PitchWall", category: "startup", priority: "low" },
  { name: "ProofStories", category: "startup", priority: "low" },
  { name: "Proofy", category: "startup", priority: "low" },
  { name: "Read.cv", category: "community", priority: "low" },
  { name: "SaaS AI Tools", category: "ai", priority: "medium" },
  { name: "SaaSFame", category: "saas", priority: "low" },
  { name: "SaaSworthy", category: "saas", priority: "medium" },
  { name: "ShipIt Buzz", category: "startup", priority: "low" },
  { name: "ShipYard HQ", category: "startup", priority: "low" },
  { name: "Shipsquad", category: "startup", priority: "low" },
  { name: "ShowMeBestAI", category: "ai", priority: "low" },
  { name: "Side Projectors", category: "startup", priority: "medium" },
  { name: "Slocco", category: "startup", priority: "low" },
  { name: "Software World", category: "saas", priority: "medium" },
  { name: "SolutionsFast", category: "general", priority: "low" },
  { name: "SpeedLaunch", category: "startup", priority: "low" },
  { name: "StackerNews", category: "community", priority: "low" },
  { name: "Startups.fyi", category: "startup", priority: "medium" },
  { name: "Startup Inspire", category: "startup", priority: "low" },
  { name: "Startup Ranked", category: "startup", priority: "low" },
  { name: "Startupbase", category: "startup", priority: "medium" },
  { name: "StartupSlabSite", category: "startup", priority: "low" },
  { name: "StartupStash", category: "startup", priority: "medium" },
  { name: "StartupSubmit", category: "startup", priority: "low" },
  { name: "TapRefer", category: "deals", priority: "low" },
  { name: "Tekpon", category: "saas", priority: "medium" },
  { name: "The Grommet", category: "general", priority: "low" },
  { name: "TinyLaunch", category: "startup", priority: "low" },
  { name: "TinyStartups", category: "startup", priority: "low" },
  { name: "ToolFame", category: "ai", priority: "low" },
  { name: "Toolfolio", category: "ai", priority: "low" },
  { name: "Top10Now", category: "general", priority: "low" },
  { name: "TrustMRR", category: "saas", priority: "low" },
  { name: "TryLaunch", category: "startup", priority: "low" },
  { name: "TryLaunchAI", category: "ai", priority: "low" },
  { name: "Turbo0", category: "startup", priority: "low" },
  { name: "TwelveTools", category: "ai", priority: "low" },
  { name: "Uneed", category: "startup", priority: "medium" },
  { name: "WaitJoin", category: "startup", priority: "low" },
  { name: "WIP", category: "community", priority: "medium" },
  { name: "Workspaces.xyz", category: "community", priority: "low" },
];

export const DIRECTORY_CATEGORIES: Record<DirectoryEntry["category"], string> = {
  ai: "AI Directories",
  startup: "Startup Platforms",
  saas: "SaaS Directories",
  general: "General Directories",
  community: "Communities",
  deals: "Deals & Marketplaces",
};
